<template>
  <div>
    <!-- 固定导航栏 -->
    <div class="fixed-navbar">
      <el-card shadow="never" class="navbar-card">
        <div class="navbar-content">
          <navBar class="navbar-left" :is-type="3" :category-type="1" />
          <div class="navbar-center">
            {{ detailTitle || '' }} 红人选品
            <span class="status-label" :style="statusLabelStyle">
              {{ progressStatusAliasMap[dressRow.progress_status] || '--' }}
            </span>
          </div>
          <div class="navbar-right" v-if="hasPermission('lb_kol_video_log')">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-document"
              @click="showLogDialog = true">
              操作日志
            </el-button>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-page-content">
      <!-- 基本信息 + 需求明细 -->
      <div
        class="info-demand-section section-content"
        ref="infoSection">
        <div class="info-container">
          <lbInfo :infoRow="dressRow" v-if="dressRow.id" @close="getInfo" />
        </div>

        <!-- 需求明细 -->
        <div
          v-if="hasPermission('lb_kol_video_demand_list')"
          class="demand-container">
          <DemandItemList
            :lb-id="id"
            :progress-status="progress_status"
            :can-edit="canEdit"
            @commit-demand="commitDemand" />
        </div>
      </div>

      <!-- 选品列表 -->
      <div
        class="selection-section section-content"
        ref="selectionSection">
        <video-selection-table
          :id="dressRow.id"
          v-if="hasPermission('lb_kol_video_selection_list') && id"
          :show-header="false"
          :detail-title="detailTitle" />
      </div>
    </div>
    <!--    发起需求-->
    <!--    <CommitDemandConfirm :configType="'dress'" :visible.sync='openDemandConfirm' :id='id' @close='getInfo' />-->
    <!--    内部视频号选品规则-->

    <!-- 操作日志对话框 -->
    <el-dialog
      title="日志查看"
      :visible.sync="showLogDialog"
      width="40%">
      <div class="log-dialog-content">
        <!-- 日志类型选择 -->
        <div class="log-type-selector">
          <el-radio-group v-model="selectedLogTypes">
            <el-radio-button label="operation">操作日志</el-radio-button>
            <!--            <el-radio-button label="demand">需求明细日志</el-radio-button>-->
          </el-radio-group>
        </div>

        <!-- 操作日志 -->
        <div v-if="selectedLogTypes === 'operation'" class="log-section">
          <LbSelectionDressLog
            ref="refLog"
            :info-id="id"
            :is-type="3"
            :key="'operation-' + selectedLogTypes"
            v-if="showLogDialog && id" />
        </div>

        <!-- 需求明细日志 -->
        <!--        <div v-if="selectedLogTypes === 'demand'" class="log-section">-->
        <!--          <LbSelectionDressLog-->
        <!--              ref="refLog"-->
        <!--              :info-id="id"-->
        <!--              :op-type="'demand_import,demand_export,demand_save,demand_delete'"-->
        <!--              :is-type="3"-->
        <!--              :key="'operation-' + selectedLogTypes"-->
        <!--              v-if="showLogDialog && id" />-->
        <!--&lt;!&ndash;          <LogList&ndash;&gt;-->
        <!--&lt;!&ndash;            ref="refDemandLog"&ndash;&gt;-->
        <!--&lt;!&ndash;            :info-id="id"&ndash;&gt;-->
        <!--&lt;!&ndash;            :op-type="'demand_import,demand_export,demand_save,demand_delete'"&ndash;&gt;-->
        <!--&lt;!&ndash;            :key="'demand-' + selectedLogTypes"&ndash;&gt;-->
        <!--&lt;!&ndash;            v-if="showLogDialog && id" />&ndash;&gt;-->
        <!--        </div>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import LbSelectionDressLog from '@/pages/lb/dress/components/LbSelectionDressLog.vue'
import LogList from '@/pages/lb/components/LogList.vue'
import CreateEdit from '@/pages/lb/kol/CreateEdit.vue'
import lbInfo from '@/pages/lb/components/lbInfo.vue'
import DressSelectionTable from '@/pages/lb/dress/dressProduct/dressSelectionTable.vue'
import DemandItemList from '@/pages/lb/dress/videoProduct/DemandItemList.vue'
import CommitDemandConfirm from '@/pages/lb/components/CommitDemandConfirm.vue'
import navBar from "@/pages/lb/components/navBar.vue";
import VideoSelectionTable from "./VideoSelection.vue";

// 进度状态配置
const PROGRESS_STATUS_OPTIONS = [
  { label: '新创建', value: 1, color_value: '#FFFFFF', class_name: 'status-new' },
  { label: '已发需求', value: 2, color_value: '#67C23A', class_name: 'status-launch' },
  { label: '初选完成', value: 3, color_value: '#409EFF', class_name: 'status-original' },
  { label: '确认完成', value: 4, color_value: '#E6A23C', class_name: 'status-ack' },
  { label: '锁定表格', value: 5, color_value: '#F56C6C', class_name: 'status-lock' }
]

export default {
  name: 'DressVideoProductIndex',
  components: {
    VideoSelectionTable,
    navBar,
    CommitDemandConfirm,
    DemandItemList,
    DressSelectionTable,
    CreateEdit,
    LbSelectionDressLog,
    lbInfo,
    LogList
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    canEdit() {
      return (this.userPermissions.indexOf('lb_schedule_edit_leader') > -1 || this.dressRow.leader_id === this.userInfo.id)
    },

    // 进度状态映射
    progressStatusMap() {
      return this.createStatusMap('class_name')
    },

    progressStatusAliasMap() {
      return this.createStatusMap('label')
    },

    progressStatusColorMap() {
      return this.createStatusMap('color_value')
    },

    // 页面标题
    detailTitle() {
      if (!this.dressRow.id) return ''
      const date = this.$utils.parseTime(this.dressRow.start_at, '{y}年{m}月{d}日')
      return `${date}【${this.dressRow.nickname}】${this.dressRow.platform_name}`
    },

    // 状态标签样式
    statusLabelStyle() {
      return {
        fontSize: '14px',
        textAlign: 'center',
        borderRadius: '5px',
        padding: '2px 8px',
        margin: '1px',
        border: '#7d8086 1px solid',
        backgroundColor: this.progressStatusColorMap[this.dressRow.progress_status]
      }
    }
  },
  data() {
    return {
      // 页面数据
      id: null,
      loading: false,
      showLog: false,
      open: false,
      custom_type: 'add',
      dressRow: {},
      progress_status: 1,
      openDemandConfirm: false,

      // 对话框状态
      showLogDialog: false,
      selectedLogTypes: 'operation',

      // 配置
      progressStatusOptions: PROGRESS_STATUS_OPTIONS
    }
  },
  methods: {
    /**
     * 初始化页面
     */
    init() {
      this.getInfo()
    },

    /**
     * 获取排期信息
     */
    async getInfo() {
      try {
        const { info } = await this.$api.getLbScheduleInfo(this.id)
        this.dressRow = info
        this.progress_status = info.progress_status

        this.$nextTick(() => {
          document.title = `【${info.nickname}】红人选品`
        })
      } catch (error) {
        console.error('获取排期信息失败:', error)
      }
    },

    /**
     * 发起需求
     */
    commitDemand() {
      this.openDemandConfirm = true
    },

    /**
     * 权限检查
     */
    hasPermission(permission) {
      return this.userPermissions.indexOf(permission) > -1
    },

    /**
     * 创建状态映射
     */
    createStatusMap(key) {
      const map = {}
      this.progressStatusOptions.forEach(item => {
        map[item.value] = item[key]
      })
      return map
    },


    onOpen() {
      this.getInfo()
      this.showLog = false
      // this.dialogTitle = `红人选品会-上(ID:${this.lbId})`
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
  created() {
    this.id = this.$route.params.id || this.$route.query.id
    this.getInfo()
  }
}
</script>
<style scoped>
/* 导航栏样式 */
.fixed-navbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

/* 导航栏固定状态样式 */
.fixed-navbar.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
  animation: navbarSlideDown 0.3s ease;
}

@keyframes navbarSlideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

::v-deep .el-card__body {
  padding: 0 !important;
}

.navbar-card {
  border: none;
  border-radius: 0;
}

.navbar-content {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 0 20px;
}

.navbar-left {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 10px;
}

.navbar-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

.navbar-right {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.status-label {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  text-align: center;
  border-radius: 5px;
  padding: 2px 8px;
  margin: 1px;
  border: #7d8086 1px solid;
  background-color: #FFFFFF;
  color: #000c17;
}

/* 主要内容区域样式 */
.main-page-content {
  padding: 80px 20px 20px;
  transition: padding-top 0.3s ease;
}

.no-top-padding {
  padding-top: 0px !important;
}

/* 信息需求区域 */
.info-demand-section {
  margin-bottom: 20px;
  min-height: 90vh;
}

.info-container {
  overflow: hidden;
}

.demand-container {
  margin-top: 20px;
}

/* 选品列表区域 */
.selection-section {
  margin-top: 10px;
  margin-bottom: 20px;
  min-height: 90vh;
}

/* 激活状态的样式 */
.active-section {
  width: 100%;
  background-color: white;
  transition: all 0.3s ease;
}

.active-section .el-divider__text {
  background-color: white;
  color: #409EFF;
  font-weight: bold;
}

/* 进度状态样式 */
.status-new {
  background-color: #FFFFFF;
  color: #000c17;
}

.status-launch {
  background-color: #67C23A;
  color: #fefefe;
}

.status-original {
  background-color: #409EFF;
  color: #fefefe;
}

.status-ack {
  background-color: #E6A23C;
  color: #fefefe;
}

.status-lock {
  background-color: #F56C6C;
  color: #fefefe;
}
.log-type-selector {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.log-type-selector .el-checkbox-group {
  display: flex;
  gap: 20px;
}

</style>
